<template>
    <div
        v-for="(item, index) in items"
        :key="item.key"
        class="section-container"
        @mouseenter="hoverKey = item.key"
        @mouseleave="hoverKey = null"
    >
        <FabWrapper
            v-if="isReviewModeActive && $reviewStore.review"
            :invertedIndex="items.length - index + 10"
            :hovering="hoverKey === item.key"
            :section="item.section"
        />
        <component
            :is="item.component"
            :id="item.sectionId"
            :section="item.section"
            :class="item.className"
        />
    </div>
</template>

<script>
import PortfolioHeroSection from "@/scripts/view/portfolio/sections/PortfolioHeroSection.vue";
import PortfolioNavigationSection from "@/scripts/view/portfolio/sections/PortfolioNavigationSection.vue";
import FabWrapper from "@/scripts/view/review/components/FabWrapper.vue";

export default {
    name: "ViewHeaderSections",
    components: {
        FabWrapper,
        PortfolioHeroSection,
        PortfolioNavigationSection,
    },
    props: {
        showPortfolioHero: {
            type: Boolean,
            default: false,
        },
        portfolioHeroSection: {
            type: Object,
            default: null,
        },
        portfolioNavigationSection: {
            type: Object,
            default: null,
        },
        navigationVisibility: {
            type: Object,
            default: () => ({}),
        },
        isSidebarHeroLayout: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hoverKey: null,
        };
    },
    computed: {
        isReviewModeActive() {
            return this.$route.path.includes("/review/");
        },
        items() {
            const items = [];

            if (this.navigationVisibility?.showAbove && this.portfolioNavigationSection?._id) {
                items.push({
                    key: "nav-above",
                    component: "PortfolioNavigationSection",
                    section: this.portfolioNavigationSection,
                    sectionId: `section-${this.portfolioNavigationSection._id}`,
                    className: null,
                });
            }

            if (this.showPortfolioHero && this.portfolioHeroSection) {
                items.push({
                    key: "portfolio-hero",
                    component: "PortfolioHeroSection",
                    section: this.portfolioHeroSection,
                    sectionId: `section-${this.portfolioHeroSection._id}`,
                    className: null,
                });
            }

            if (this.navigationVisibility?.showBelow && this.portfolioNavigationSection?._id) {
                items.push({
                    key: "nav-below",
                    component: "PortfolioNavigationSection",
                    section: this.portfolioNavigationSection,
                    sectionId: `section-${this.portfolioNavigationSection._id}`,
                    className: this.isSidebarHeroLayout ? "is-below" : null,
                });
            }

            return items;
        },
    },
};
</script>

<style lang="scss" scoped>
.section-container {
    position: relative;
}
</style>
